// Packages and components
import React from 'react';
import { Box } from 'grommet';
import SHDButton from '@ui/Button/SHDButton';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDModalContainer from '@ui/ModalContainer/SHDModalContainer';
import SHDText from '@ui/Text/SHDText';

// Types and Interfaces
import type { UserCannotModalProps } from '../schedule.d';

const UserCannotModal: React.FC<UserCannotModalProps> = ({
  heading,
  body,
  onClose,
}) => {
  return (
    <>
      <SHDModalContainer isFirst>
        <Box margin={{ bottom: 'xxlarge' }}>
          <SHDHeading
            level={3}
            formatCasing={false}
            margin={{ bottom: 'medium' }}
          >
            {heading}
          </SHDHeading>

          {body && (
            <SHDText style="subhead" color="black-alpha-80">
              {body}
            </SHDText>
          )}
        </Box>

        <Box direction="row" gap="small">
          <SHDButton primary label="Go back" onClick={() => onClose()} />
        </Box>
      </SHDModalContainer>
    </>
  );
};

export default UserCannotModal;
